// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sEAjb","textarea":"styles_textarea__3Ev5r"};